import React, { FC, useCallback, useMemo, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import __ from "src/utils/Translations";
import Select from "react-select";
import useFetchAreasData from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api/useFetchAreasData";
import { debounce } from "lodash";

interface IAreasField {
  companyId: string;
  structureId: string;
  value: any;
  onChange: (value: any) => void;
  isEditable: boolean;
  isDisabled?: boolean;
  label: string;
  error?: { message?: string };
}

const AreasField: FC<IAreasField> = ({
  companyId,
  structureId,
  value,
  onChange,
  isEditable,
  isDisabled,
  label,
  error,
}) => {
  const [inputValue, setInputValue] = useState<string>("");

  const { data, isFetching, fetchNextPage, hasNextPage } = useFetchAreasData(
    companyId,
    structureId,
    inputValue
  );

  const fetchedAreas = useMemo(
    () =>
      data?.pages.flatMap((page) =>
        page.content.map((area: { id: string; label: string }) => ({
          value: area.id,
          label: area.label,
        }))
      ) || [],
    [data]
  );

  const handleInputChange = useCallback(
    debounce((value) => {
      setInputValue(value);
    }, 1000),
    []
  );

  const handleScrollToBottom = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const customStyles = (hasError: boolean) => ({
    control: (provided: any) => ({
      ...provided,
      borderColor: hasError ? "red" : provided.borderColor,
      boxShadow: hasError ? "0 0 0 1px red" : provided.boxShadow,
      "&:hover": {
        borderColor: hasError ? "red" : provided.borderColor,
      },
    }),
  });

  return (
    <>
      <FormGroup>
        {label && <Label for="area">{label}</Label>}
        <Select
          id="area"
          value={value}
          onChange={onChange}
          menuPlacement="auto"
          options={fetchedAreas}
          onInputChange={handleInputChange}
          onMenuScrollToBottom={handleScrollToBottom}
          placeholder={
            isDisabled
              ? __(
                  "Wybrany obszar nie zawiera ustawionego wyświetlanego dodatkowego obszaru"
                )
              : __("Wybierz")
          }
          noOptionsMessage={() => {
            if (isFetching) return __("Ładowanie...");
            return fetchedAreas.length > 0
              ? null
              : __("Brak wyników wyszukiwania");
          }}
          loadingMessage={() => __("Ładowanie...")}
          isClearable
          isLoading={isFetching}
          isDisabled={!isEditable || isDisabled}
          styles={customStyles(!!error)}
        />
      </FormGroup>
    </>
  );
};

export default AreasField;
